var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-product-write-off")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("app-product-sku-autocomplete", {
                    model: {
                      value: _vm.product,
                      callback: function ($$v) {
                        _vm.product = $$v
                      },
                      expression: "product",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "6" } },
                [
                  _c("w-input-number", {
                    attrs: { fancy: "", label: _vm.$ct("qty") },
                    model: {
                      value: _vm.Qty,
                      callback: function ($$v) {
                        _vm.Qty = $$v
                      },
                      expression: "Qty",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-button", { on: { click: _vm.cancel } }, [
            _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " "),
          ]),
          _c("w-spacer"),
          _c(
            "w-button",
            { attrs: { disabled: !_vm.product }, on: { click: _vm.confirm } },
            [_vm._v(" " + _vm._s(_vm.$t("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }